import { Link } from "react-router-dom";

const COPY = {
  none: {
    eyebrow: "Subscription required",
    title: "You don't have a Click Law subscription",
    body: "Your firm or lawyer account needs an active plan before you can use the dashboard.",
    cta: { to: "", label: "View plans" },
  },
  expired: {
    eyebrow: "Subscription expired",
    title: "Your Click Law subscription has expired",
    body: "Renew a plan to continue using requests, chats, and the rest of your dashboard.",
    cta: { to: "", label: "Renew a plan" },
  },
  suspended: {
    eyebrow: "Access paused",
    title: "Your subscription has been suspended",
    body: "This account cannot use the dashboard while the subscription is suspended. Contact Click Law if you think this is a mistake.",
    cta: { to: "/contact", label: "Contact us" },
  },
};

export default function SubscriptionBlockedPage({ state = "none", role = "firm" }) {
  const copy = COPY[state] || COPY.none;
  const plansPath = role === "lawyer" ? "/plans/personal" : "/plans/business";
  const ctaTo = copy.cta.to || plansPath;

  return (
    <section className="cl-sub-block">
      <div className="cl-sub-block-card">
        <p className="cl-eyebrow">{copy.eyebrow}</p>
        <h1>{copy.title}</h1>
        <p>{copy.body}</p>
        <div className="cl-sub-block-actions">
          <Link to={ctaTo} className="btn btn-solid">
            {copy.cta.label}
          </Link>
          {state !== "suspended" ? (
            <Link to="/contact" className="btn btn-outline">
              Contact us
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
}
